"use strict";
import { __require as h } from "./index.es226.js";
import { __require as q } from "./index.es227.js";
import { __require as M } from "./index.es104.js";
import { __require as _ } from "./index.es103.js";
var n, u;
function w() {
  if (u) return n;
  u = 1;
  var o = /* @__PURE__ */ h(), t = /* @__PURE__ */ q(), s = /* @__PURE__ */ M(), f = /* @__PURE__ */ _(), i = o("%Map%", !0), c = t("Map.prototype.get", !0), v = t("Map.prototype.set", !0), l = t("Map.prototype.has", !0), d = t("Map.prototype.delete", !0), m = t("Map.prototype.size", !0);
  return n = !!i && /** @type {Exclude<import('.'), false>} */
  function() {
    var e, p = {
      assert: function(r) {
        if (!p.has(r))
          throw new f("Side channel does not contain " + s(r));
      },
      delete: function(r) {
        if (e) {
          var a = d(e, r);
          return m(e) === 0 && (e = void 0), a;
        }
        return !1;
      },
      get: function(r) {
        if (e)
          return c(e, r);
      },
      has: function(r) {
        return e ? l(e, r) : !1;
      },
      set: function(r, a) {
        e || (e = new i()), v(e, r, a);
      }
    };
    return p;
  }, n;
}
export {
  w as __require
};
//# sourceMappingURL=index.es106.js.map
